var React = require('react');

function ContactTriangleMobile2 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M89.0547 79.6465L75.3374 1.39728M89.0547 79.6465L49.0623 44.1999M89.0547 79.6465L3.13585 35.0583M75.3374 1.39728L49.0623 44.1999M75.3374 1.39728L3.13585 35.0583M49.0623 44.1999L3.13585 35.0583","stroke":"#FF9EB6"}));
}

ContactTriangleMobile2.defaultProps = {"width":"90","height":"84","viewBox":"0 0 90 84","fill":"none"};

module.exports = ContactTriangleMobile2;

ContactTriangleMobile2.default = ContactTriangleMobile2;
